import React from "react";
import { navigate } from "@reach/router";

import ProjectContent from "./projectContent";

class ProjectContentContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imagesToLoad: 0,
      imagesLoaded: 0
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleImageCreate = this.handleImageCreate.bind(this);
    this.handleImageLoad = this.handleImageLoad.bind(this);
  }

  componentDidUpdate() {
    if (
      this.state.imagesToLoad > 0 &&
      this.state.imagesToLoad === this.state.imagesLoaded &&
      this.props.loaded === false
    ) {
      window.setTimeout(() => {
        this.props.handleRouteLoad(true);
      }, 500);
    }
  }

  handleClick() {
    this.props.handleRouteLoad(false, () => {
      window.setTimeout(() => {
        navigate(`/`);
      }, 310);
    });
  }

  handleImageCreate() {
    this.setState(previousState => {
      return { imagesToLoad: previousState.imagesToLoad + 1 };
    });
  }

  handleImageLoad() {
    this.setState(previousState => {
      return { imagesLoaded: previousState.imagesLoaded + 1 };
    });
  }

  render() {
    return (
      <div>
        <ProjectContent
          project={this.props.project}
          handleClick={this.handleClick}
          handleImageCreate={this.handleImageCreate}
          handleImageLoad={this.handleImageLoad}
        />
      </div>
    );
  }
}
export default ProjectContentContainer;
